import styled from "styled-components";

export const StyledAlert = styled.p`
    background-color: ${p => p.theme.c.info};
    max-width: 460px;
    padding: 6px;
    margin: auto;
    border-radius: 8px;
    box-shadow: 0 0 5px 1px ${p => p.theme.c.blackShadow1};
    color: white;
    margin-bottom: 20px;
    text-shadow: 0 0 3px ${p => p.theme.c.blackShadow35};

    .i-alert {
        font-size: 18px;
        position: relative;
        top: 2px;
    }
`;
